export default "__VITE_ASSET__pJvGXceh__"